import { render, staticRenderFns } from "./NewsMediaCreate.vue?vue&type=template&id=38a4d87e&lang=pug"
import script from "./NewsMediaCreate.vue?vue&type=script&lang=js"
export * from "./NewsMediaCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports